// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1ddA-","header":"styles_header__2fNza","body":"styles_body__1fhs4"};